import {
  Environment,
  OrbitControls,
  Reflector,
  useTexture,
} from "@react-three/drei";
import { Canvas, useFrame } from "@react-three/fiber";
import { SingleCasementWindow } from "../models/SingleCasementWindow";

import { useRef } from "react";
import * as THREE from "three";
import { BuildingExterior } from "../models/buildingExterior";
import { BuildingInterior } from "../models/buildingInterior";
import styles from "../styles/viewer3d.module.sass";

const MAXANGLE = -115;//75;

function Ground() {
  const [floor, normal] = useTexture([
    "/SurfaceImperfections003_1K_var1.jpg",
    // "/textures/laminate_floor_02_1k/laminate_floor_02_diff_1k.jpg",
    "/SurfaceImperfections003_1K_Normal.jpg",
    // "/textures/laminate_floor_02_1k/laminate_floor_02_nor_gl_1k.jpg",
  ]);
  return (
    <Reflector
      blur={[400, 100]}
      resolution={512}
      args={[20, 20]}
      mirror={0.5}
      mixBlur={6}
      mixStrength={1.5}
      rotation={[-Math.PI / 2, 0, Math.PI / 2]}
    >
      {(Material, props) => (
        <Material
          color="#ffffff"
          metalness={0.4}
          // scale={[100,100]}
          roughnessMap={floor}
          normalMap={normal}
          normalScale={[2, 2]}
          {...props}
        />
      )}
    </Reflector>
  );
}

function CameraControls() {
  const controlsRef = useRef();

  useFrame(() => {
    if (controlsRef.current) {
      // Get the current rotation in degrees
      const azimuthalAngle = THREE.MathUtils.radToDeg(
        controlsRef.current.getAzimuthalAngle()
      );

      if (azimuthalAngle < -MAXANGLE) {
        controlsRef.current.setAzimuthalAngle(
          THREE.MathUtils.degToRad(-MAXANGLE)
        );
      } else if (azimuthalAngle > MAXANGLE) {
        controlsRef.current.setAzimuthalAngle(
          THREE.MathUtils.degToRad(MAXANGLE)
        );
      }

      // Update the controls
      controlsRef.current.update();
    }
  });

  return (
    <OrbitControls
      // ref={controlsRef}
      maxDistance={3}
      minDistance={0.25}
      maxPolarAngle={(Math.PI / 180) * 120}
      minPolarAngle={(Math.PI / 180) * 65}
      target={[0, 9.25, 0]}
    />
  );
}

export default function viewer3d({
  windowOpen,
  dayNightCycle,
  interiorExterior,
  activeConfig,
  activeHinge,
  activeBugscreen,
  activeBlind,
  activeBlindDirection,
  activePaintColor,
  activePaintedSide,
  activePremiumCenterLock,
  activeHardware,
  activeFrostedGlass,
  activeGrillStyle,
  activeGrillPattern,
  activeSDLStyle,
  activeSDLPattern,
  activeExtraScreenBlindCartridge,
  activeLimiter,
  activeNightLock,
}) {
  return (
    <Canvas
      className={styles.imagine_io_smartobject_player}
      shadows
      dpr={[1, 1.5]}
      id={"visibleCanvas"}
      camera={{ fov: 60, near: 0.1, far: 100, position: [-1.5, 10, 3] }}
      style={{ background: "#ffffff" }}
      gl={{ preserveDrawingBuffer: true }}
      // frameloop="demand"
    >
      <CameraControls />

      <Environment
        background="true"
        // preset="city"
        files={dayNightCycle ? "/hdri/night_2k.hdr" : "/hdri/day_2k.hdr"}
        backgroundRotation={[0, Math.PI / 2, 0]}
        ground={{
          height: 15, // Height of the camera that was used to create the env map (Default: 15)
          radius: 200, // Radius of the world. (Default 60)
          scale: 1000, // Scale of the backside projected sphere that holds the env texture (Default: 1000)
        }}
      />

      {/* Lights */}
      {/* <ambientLight intensity={1} /> */}
      {dayNightCycle ? null : (
        <>
          <directionalLight position={[1, 1, -1]} intensity={3} />
          <directionalLight position={[-1, 1, -1]} intensity={0.5} />
        </>
      )}

      <SingleCasementWindow
        position={[0, 8.49, 0]}
        windowOpen={windowOpen}
        activeConfig={activeConfig}
        activeHinge={activeHinge}
        activeBugscreen={activeBugscreen}
        activeBlind={activeBlind}
        activeBlindDirection={activeBlindDirection}
        activePaintColor={activePaintColor}
        activePaintedSide={activePaintedSide}
        activePremiumCenterLock={activePremiumCenterLock}
        activeHardware={activeHardware}
        activeFrostedGlass={activeFrostedGlass}
        activeGrillStyle={activeGrillStyle}
        activeGrillPattern={activeGrillPattern}
        activeSDLStyle={activeSDLStyle}
        activeSDLPattern={activeSDLPattern}
        activeExtraScreenBlindCartridge={activeExtraScreenBlindCartridge}
        activeLimiter={activeLimiter}
        activeNightLock={activeNightLock}
      />
      <BuildingExterior />
      <BuildingInterior />
    </Canvas>
  );
}
